import type { QueryClient } from '@tanstack/react-query';
import { redirect } from '@tanstack/react-router';

import { hasPermission } from '@/entities/practice-member';

type OnlinePaymentsBeforeLoadArgs = {
    context: { queryClient: QueryClient };
};

export async function onlinePaymentsBeforeLoad({ context }: OnlinePaymentsBeforeLoadArgs) {
    if (!(await hasPermission(context.queryClient, ['OWNER', 'EHR_BASE']))) {
        throw redirect({ to: '/settings/profile' });
    }
}
